import { useEffect } from 'react';

const useEscapeKey = (onClose) => {
  useEffect(() => {
    const fn = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', fn);
    return () => document.removeEventListener('keydown', fn);
  }, [onClose]);
};

export default useEscapeKey;
